module.exports = __webpack_public_path__ + "img/header.a924c34f.png";